import { createGlobalStyle } from 'antd-style'

export const AppStyles = createGlobalStyle(() => ({
    'html, body': {
        color: 'rgb(0 0 0 / 88%)',
        margin: 0,
    }
}))
